import React, { useCallback, useContext, useEffect, useState } from 'react';
import RefreshButton from '../Usables/RefreshButton';
import BasicButton, { DateWiseListButton, DeleteButton, DownloadButton, ListButton } from '../Usables/Buttons';
import PageBanner from '../Usables/PageBanner';
import axios from 'axios';
import { basePath, formatDate, isObject, isValidDateTillCurrent, validateFile, validateNumber, validatePhoneNumber } from '../Constants/constant';
import InputField from '../Usables/InputField';
import EditCandidate from '../Usables/EditCandidate';
import Dropdown from '../Usables/Dropdown';
import Loader from '../Usables/Loader';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { AppContext } from '../ContextApi/ContextApi';
import Pagination from '../Usables/Pagination';
import NoRecords from '../Usables/NoRecords';
import { useNavigate, useParams } from 'react-router-dom';
import CloseModal from '../Usables/CloseModal';

const CvExcelList = ({onClose}) => {
    const { index } = useParams();
    const {apiHeaderJSON, user} = useContext(AppContext);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [pagination, setPagination] = useState({page: 1, totalRecords: "", totalPages: "", limit: 10,});
    const [filterData, setFilterData] = useState({});
    const [ischanged, setIschanged] = useState({getListChanged: false, fetchFilterDataChanged: false, statusChanged: false});
    
    const getList = useCallback(async()=> {
        try {
            const options = {
                params: {
                    limit: pagination?.limit,
                    page: pagination?.page,
                    filter: JSON.stringify(filterData)
                },
                headers: apiHeaderJSON,
            }
            const apiUrl = `${basePath}/GetUploadedCVExcels`;
            const response = await axios.get(apiUrl, options);
            // console.log("getSourcingReportByDate===>", response.data);
            setRows(response.data?.data);
            setPagination({...pagination, totalPages: response?.data?.pages, totalRecords: response?.data?.totalRecords});
            setLoading(false);
            setLoadingFilter(false);
        } catch (error) {
            setLoading(false);
            setLoadingFilter(false);
            console.log(error);
        }
    },[apiHeaderJSON, pagination, filterData]);

    useEffect(()=> {
        setLoading("1");
        getList();
    },[]);
    
    useEffect(()=> {
        if (ischanged?.getListChanged) {
            getList();
            setIschanged({...ischanged, getListChanged: false});
        }
    },[ischanged?.getListChanged]);

    const handleRefresh = () => {
        if (!loading || !loadingFilter) {
            setLoading("1");
            getList();
        }
    }

    const handleChangeFilter = useCallback((event)=> {
        const {name, value} = event?.target;
        // console.log("name, value", name, value);
        setFilterData({ ...filterData, [name]: value, });       
    },[filterData]);

    const handleFilter = useCallback(()=>{ 
        setLoadingFilter("1"); 
        getList();
    },[getList]);
    const handleClear = useCallback(()=> {
        setLoadingFilter("2");
        setFilterData({fromDate: "", toDate: ""});
        setIschanged({...ischanged, getListChanged: true});
    },[ischanged]);

    const handleLimit = (e)=> {
        setPagination({...pagination, limit: e.target.value});
        setIschanged({...ischanged, getListChanged: true});
    }
    const handlePrev = (e)=> {
        if (pagination?.page > 1) {
            setPagination({...pagination, page: pagination?.page - 1});
            setIschanged({...ischanged, getListChanged: true});
        }
    }
    const handleNext = (e)=> {
        
        if (pagination?.totalPages > pagination?.page) {
            setPagination({...pagination, page: pagination?.page + 1});
            setIschanged({...ischanged, getListChanged: true});
        }
    }

    const handleExcelExport = async (id) => {
        try {
            Swal.fire({
                title: 'Please wait...',
                html: 'Downloading...',
                allowOutsideClick: false,
                didOpen: () => {Swal.showLoading();}
            });
            const response = await axios.get(`${basePath}/DownloadCVExcel/${id}`, {
                responseType: 'blob', // Ensure response is treated as a blob
                headers:apiHeaderJSON
            });

            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'cv management excel.xlsx');
            document.body.appendChild(link);
            link.click();

            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            Swal.close();
        } catch (error) {
            Swal.close();
            console.error('There was a problem with the download:', error);
            toast.error(error?.response?.data?.error || "There was a problem with the download");
        }
    }

    return (
         <section className=' w-full h-screen fixed left-0 top-0 z-20 flex items-center justify-center blurBack'>
            <div onClick={(e) => { e.stopPropagation(); }} className='relative w-[70vw] bg-white overflow-auto mx-10 mb-5 py-5 px-8 rounded-2xl '>
            <CloseModal disabled={loading} onClick={onClose} />
            {/* RefreshButton => used for refresh table data */}
            <RefreshButton onClick={handleRefresh} position='fixed' />
            <div className='h-full max-h-[90vh] w-full  rounded-2xl overflow-y-scroll noScrollbar pt-4 px-0.5'>
                {/* filter */}
                <div className=' grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 items-center gap-3 grayBlurShadow bg-white p-3 mb-5 rounded-xl'>
                    <InputField  id="fromDate" name="fromDate" type="date" label="From:"
                    value={filterData?.fromDate}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="toDate" name="toDate" type="date" label="To:"
                    value={filterData?.toDate}
                    onChange={handleChangeFilter}
                    />
                    <div className="flex gap-3 col-span-1">
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Apply Filter</label>
                            <BasicButton onClick={handleFilter} buttonName='Apply Filter' className='darkPurple text-nowrap' shadow={true}
                            disabled={loading || loadingFilter || (!filterData?.fromDate && !filterData?.toDate)} 
                            loading={loadingFilter === "1"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                        </div>
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Clear Filter</label>
                            <BasicButton onClick={handleClear} buttonName='Clear Filter' className="bg-red-600 text-nowrap" shadow={true}
                            disabled={loading || loadingFilter || (!filterData?.fromDate && !filterData?.toDate)} 
                            loading={loadingFilter === "2"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-red-900" />
                        </div>
                    </div>
                </div>
                {
                    loading === "1" ?
                    <Loader/> :
                    Array.isArray(rows) && rows?.length >= 1 ?
                    <div className='tableWrapper mb-3'>
                        <div className='tableBody' style={{maxHeight: "58dvh"}}>
                            <table className='w-full table-fixed border-collapse'>
                                <thead className='tableHead'>
                                    <tr className=' bg-gray-200'>
                                        <th className='whitespace-nowrap text-center w-[12%]'>Uploaded Date</th>
                                        <th className='w-[40%] text-left'>Excel File</th>
                                        <th className='w-[20%] text-left'>Uploaded By</th>
                                        {user[index]?.delete_access && <th className='whitespace-nowrap text-center  w-[7%]'>Action</th>}
                                    </tr>
                                </thead>
                                <tbody className='tableBody'>
                                    {
                                        Array.isArray(rows) && rows?.map((val, idx) => {
                                            return (
                                                <tr key={val?.id} id={val?.id} className=' backWhite font-semibold text-sm text-left'>
                                                    <td className=' whitespace-nowrap text-center'>
                                                        <span className='line-clamp-1 text-ellipsis'>{val?.created_date ? formatDate(val?.created_date) : "--"}</span>
                                                         
                                                    </td>
                                                    <td className=' whitespace-nowrap text-left'>
                                                        <span className='line-clamp-1 text-ellipsis'>{val?.file_path}</span> 
                                                    </td>
                                                    <td className=' whitespace-nowrap text-left'>
                                                        <span className='line-clamp-1 text-ellipsis'>{val?.User?.name || '--'}</span> 
                                                    </td>
                                                    <td className=' text-center'>
                                                        <DownloadButton data={val} onClick={()=> handleExcelExport(val?.id)} tooltipName="Download Excel" />
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table >
                        </div>
                        <Pagination onLimitChange={handleLimit} onPrevChange={handlePrev} onNextChange={handleNext}
                        limit={pagination?.pagelimit} totalRecords={pagination?.totalRecords} allPages={pagination?.totalPages} page={pagination?.page}
                        disabledPrev={pagination?.page === 1} disabledNext={pagination?.page === pagination?.totalPages}
                        />
                    </div> :
                    <NoRecords/>
                }
            </div>
            </div>
        </section>
    );
}

export default CvExcelList;

